const BASE = process.env.REACT_APP_BACKEND_URL;
const j = async (r) => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); };

export const suppliersApi = {
  list: (system = "", location = "") =>
    fetch(`${BASE}/api/suppliers?system=${encodeURIComponent(system)}&location=${encodeURIComponent(location)}`).then(j),
  add: (rows) =>
    fetch(`${BASE}/api/suppliers`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(rows),
    }).then(j),
  search: (system_type, region) =>
    fetch(`${BASE}/api/suppliers/search`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ system_type, region }),
    }).then(j),
};
